import React from 'react';
import { withStyles } from '@material-ui/core';
import Typography from '../Typography';
import Input from './input';
import Icon from '../Icon';
import './style.css';
import styles from './style';
import EventDateTimeField from "./event-time";

export const LabelContainer = withStyles(styles)(({ children, classes }) => <div className={classes.labelContainer}>{children}</div>)

export default ({ eventDatetime, onTryToEdit, validator, parser, children, name, paddingOnEdit, text, handleChange, handleBlur, handleFocus, keyName, containerClasses, iconClasses, ...props }) => {
  const [initValue, setInitValue] = React.useState(text)
  const [value, setValue] = React.useState(text)
  const [focused, setFocused] = React.useState(false)
  const ref = React.createRef();

  const handleClick = () => {
    if (props.disabled) {
      onTryToEdit();
    }
  }

  const onChange = (evt) => {
    setValue(evt.target.value);
    if (typeof handleChange === "function") {
      if (keyName)
        handleChange(keyName, evt.target.value)
      else
        handleChange(evt.target.value)
    }
  }

  const onBlur = (evt) => {
    if (validator && typeof validator === "function") {
      if (!validator(evt.target.value)) {
        setValue(initValue)
        return
      }
    }
    setFocused(false)
    setInitValue(evt.target.value)
    if (typeof handleBlur === "function") {
      if (keyName)
        handleBlur(keyName, parser && typeof parser === "function" ? parser(evt.target.value) : evt.target.value)
      else
        handleBlur(parser && typeof parser === "function" ? parser(evt.target.value) : evt.target.value)
    }
  }

  const onFocus = (evt) => {
    setFocused(true)
    if (typeof handleFocus === "function") {
      if (keyName)
        handleFocus(keyName, evt.target.value)
      else
        handleFocus(evt.target.value)
    }
  }

  const onBlurEvent = () => {
    setFocused(false)
  }


  const Field = eventDatetime ? EventDateTimeField : Input;
  const conditinalProps = eventDatetime ? { onChange: handleBlur, onFocus, onBlur: onBlurEvent } : { onBlur, onFocus, onChange };
  return (

    <div onClick={handleClick} className={`hyly-editable-label-container ${paddingOnEdit && 'padding-on-edit'} ${focused && 'hyly-editable-label-focused'} ${containerClasses} `}>
      <Typography type="subtitle" font_weight="100" className="label-name">{name}</Typography>
      <Field ref={ref} {...props} value={value} {...conditinalProps} />
      {
        !props.hideEditIcon ? <Icon className={`edit ${props.textarea && ' edit-icon-bottom'} ${iconClasses}`} type="icon-pencil" size="md" /> : null
      }
    </div>
  )
}
